<script lang="ts" setup>
import { computed, type HTMLAttributes } from "vue";
import type { StepperItemProps } from "reka-ui";
import { StepperItem, useForwardProps } from "reka-ui";
import { twMerge } from "tailwind-merge";

const props = defineProps<StepperItemProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <StepperItem
    v-slot="slotProps"
    v-bind="forwarded"
    :class="twMerge('group flex items-center gap-2 data-[disabled]:pointer-events-none', props.class)"
  >
    <slot v-bind="slotProps" />
  </StepperItem>
</template>
